<template>
  <div class="cardUpdate" :class="mixinData.pageScaleValue">
    <div class="code-box">
      <img src="../../assets/cardUpdate/code.png" alt="" class="code">
    </div>
    <header class="update-title">
      <img src="../../assets/cardUpdate/title-point.png" alt="">
      <span>升级步骤</span>
    </header>
    <div class="update-progress">
      <div class="progress-item">
        <img src="../../assets/cardUpdate/icon-01.png" alt="">
        <span>保存小程序码</span>
      </div>
      <i class="iconfont etc-icon-arrow-right"></i>
      <div class="progress-item">
        <img src="../../assets/cardUpdate/icon-02.png" alt="">
        <span>微信打开并识别</span>
      </div>
      <i class="iconfont etc-icon-arrow-right"></i>
      <div class="progress-item">
        <img src="../../assets/cardUpdate/icon-03.png" alt="">
        <span>进小程序升级</span>
      </div>
    </div>
    <div class="update-detail" @click="showDetail"><span>了解详情</span><img src="../../assets/cardUpdate/detail-arrow.png" alt=""></div>

    <section class="page-bottom">
      <button class="save-code" @click="saveCode"><img src="../../assets/cardUpdate/save-code.png" alt=""></button>
      <p><img src="../../assets/cardUpdate/logo.png" alt=""><span>广西捷通与"ETC助手"联合提供服务</span></p>
    </section>
    <div class="popup" v-show="showPopup">
      <div class="popup-container">
        <div class="popup-content">
          <p has-dot>
            <i margin-r-10 class="iconfont etc-icon-dot"></i>
            <span>ETC记账卡无需充值，通行后再扣费，可在线开高速发票，35秒完成升级；</span>
          </p>
          <p has-dot>
            <i margin-r-10 class="iconfont etc-icon-dot"></i>
            <span>记账卡仅限ETC消费，无盗刷风险更安全；</span>
          </p>
          <p has-dot>
            <i margin-r-10 class="iconfont etc-icon-dot"></i>
            <span>赠送记账卡设备，新设备激活前原储值卡可正常使用；</span>
          </p>
          <p has-dot>
            <i margin-r-10 class="iconfont etc-icon-dot"></i>
            <span>原储值卡余额可提现至你记账卡绑定账户中；</span>
          </p>
          <p has-dot>
            <i margin-r-10 class="iconfont etc-icon-dot"></i>
            <span>新设备激活后，可领取8-888元随机红包，直接发送至你的微信钱包；</span>
          </p>
          <p has-dot>
            <i margin-r-10 class="iconfont etc-icon-dot"></i>
            <span>点击保存小程序码，打开微信扫一扫，点击【相册】选择保存的图片，识别后进入小程序。</span>
          </p>
          <p has-dot>
            <i margin-r-10 class="iconfont etc-icon-dot"></i>
            <span>如有其它问题，可搜索关注“ETC助手”公众号，详询在线客服</span>
          </p>
        </div>
        <div class="popup-button" @click="hideDetail">我已了解</div>
      </div>
    </div>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'

// function judgePageSize(screenHeight, screenWidth) {
//   const scale = (screenHeight / screenWidth).toFixed(2)
//   if (scale > 1.85) return 'huge'
//   if (scale > 1.8) return 'large'
//   if (scale < 1.7) return 'small'
//   return 'middle'
// }

export default {
  name: 'cardUpdate',
  mixins: [FunMixin],
  components: {},
  data() {
    return {
      // pageScale: 'middle',
      showPopup: false
    }
  },
  computed: {},
  methods: {
    showDetail() {
      console.log('showDetail')
      this.showPopup = true
    },
    hideDetail() {
      console.log('hideDetail')
      this.showPopup = false
    },
    saveCode() {
      console.log('saveCode')
      location.href = 'https://wecos.etczs.net/H5/cardUpdate/code.png'
    }
  },
  mounted() {
    // this.pageScale = judgePageSize(window.screen.height, window.screen.width)
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";

.cardUpdate {
  position: relative;
  color: #ffffff;
  background-size: cover;
  height: 100vh;
  padding-top: 550px;
  box-sizing: border-box;
  .code-box{
    position: absolute;
    width: 340px;
    height: 340px;
    border-radius: 50%;
    background-color: #fff;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    @extend %flex-center;
    .code {
      width: 300px;
      height: 300px;
      border-radius: 120px;
    }
  }
  .update-title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    position: relative;
    span {
      font-size: 38px;
      margin: 0 35px;
    }
    img {
      width: 335px;
      height: 10px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
  .update-progress {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 85px;
    height: 85px;
    margin-top: 30px;
    i{
      font-size: 26px;
    }
    .progress-item {
      width: 85px;
      height: 85px;
      position: relative;
      font-size: 0;
      img {
        width: 85px;
        height: 85px;
      }
      span {
        position: absolute;
        top: 100px;
        font-size: 30px;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
      }
    }
  }
  .update-detail {
    width: 180px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 28px;
    font-size: 0;
    background-color: #5ad6c3;
    margin: 100px auto;
    span {
      font-size: 28px;
    }
    img {
      width: 20px;
      height: 20px;
      margin-left: 10px;
    }
  }
  .page-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    font-size: 0;
    text-align: center;
    padding-bottom: 45px;
    .save-code {
      width: 506px;
      height: 110px;
      margin-bottom: 50px;
    }
    p {
      font-size: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-right: 20px;
        width: 125px;
        height: 37px;
      }
    }
  }
  .popup {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, .3);
    display: flex;
    align-items: center;
    justify-content: center;
    .popup-container {
      width: 640px;
      background-color: #fff;
      border-radius: 10px;
      padding: 50px 55px;
      .popup-content {
        font-size: 28px;
        color: #4a4a4a;
        line-height: 40px;
        p{
          margin-top: 10px;
          i{
            line-height: 40px;
          }
        }
      }
      .popup-button {
        width: 480px;
        height: 82px;
        line-height: 82px;
        text-align: center;
        margin: 35px auto 0;
        border-radius: 45px;
        font-size: 32px;
        background-image: linear-gradient(180deg, #FFD43B 0%, #FBA747 100%);
      }
    }
  }
  &.middle {
    background-image: url("../../assets/cardUpdate/bg-middle.png");
  }
  &.huge, &.large {
    background-image: url("../../assets/cardUpdate/bg-large.png");
    padding-top: 715px;
    .code {
      top: 265px;
    }
    .page-bottom {
      padding-bottom: 100px;
      .save-code {
        margin-bottom: 100px;
      }
    }
  }
  &.small {
    background-image: url("../../assets/cardUpdate/bg-small.png");
    padding-top: 480px;
    .page-bottom {
      padding-bottom: 20px;
    }
  }
}
</style>
